var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#6212d7;stroke-linecap:round;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-311 -24)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 22,
    transform: "translate(312.5 25.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 22,
    transform: "translate(312.5 35.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 22,
    transform: "translate(312.5 45.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.a2908b8539931229c7000dbc6f785267.svg";
export { ForwardRef as ReactComponent };